import React from 'react'
import '../Loader/Loader.css'

const Loader = () => {
    return (
        <div className='loader-container'>
            <div className='lds-dual-ring'></div>
        </div>
    )
}

export default Loader
